import Vue from 'vue'
import Vuex from 'vuex'

import config from "./assets/js/config";
const Cookies = require("js-cookie");

Vue.use(Vuex)

export default new Vuex.Store({
  state: {
    username: '',
    avatar: '',
    inviteCode: '',
    balance: 0,
    currency: '',
    isLogin: false,
    currentWithdraw: '',
    withdrawData: []
  },
  mutations: {
    setUsername(state, n) {
      state.username = n;
    },

    setAvatar(state, url) {
      state.avatar = url;
    },

    setInviteCode(state, code) {
      state.inviteCode = code;
    },

    setBalance(state, num) {
      state.balance = num;
    },

    setCurrency(state, code) {
      state.currency = code;
    },

    setLogin(state, flag) {
      state.isLogin = flag;
    },

    setWithdrawData(state, data) {
      state.withdrawData.splice(0);

      for(let i = 0; i < data.length; i++) {
        Vue.set(state.withdrawData, i, data[i]);
      }
    }
  },
  actions: {
    setUsername(context, n) {
      context.commit('setUsername', n);
    },

    setAvatar(context, url) {
      context.commit('setAvatar', url);
    },

    setInviteCode(context, code) {
      context.commit('setInviteCode', code);
    },

    setBalance(context, num) {
      context.commit('setBalance', num);
    },

    setCurrency(context, code) {
      context.commit('setCurrency', code);
    },

    setLogin(context, res) {
      if(res.flag) {
        Cookies.set(config.cookieName, JSON.stringify(res), {
          expires: config.cookieExpire,
        });
      }else{
        Cookies.remove(config.cookieName);
      }
      context.commit('setLogin', res.flag);
    },

    setWithdrawData(context, data) {
      context.commit('setWithdrawData', data);
    }
  }
})
